import axios from "axios";
import { triggerSnackbar } from "../../Services/NotificationService";
import { removeLocalStorageItem, showError } from "../../Utils/Index";

export const version = "api/v1";
// export const APIURL = `http://192.168.1.124:3005/${version}/`;
// export const ImageUrl = `http://192.168.1.124:3005`;
//  export const SocketURL="ws://192.168.1.124:3005"

export const APIURL=`https://api.themealcode.com/${version}/`
export const ImageUrl = `https://api.themealcode.com`;
export const SocketURL="wss://api.themealcode.com"

const ApiService = axios.create({
  baseURL: APIURL,
});

// Add a request interceptor
ApiService.interceptors.request.use((config) => {
  return config;
});
// Add a response interceptor
ApiService.interceptors.response.use(
  (response) => {
    if (response.data.status === "success" || response.data.success||response.data.status) {
      return response.data;
    } else if (response.data.message) {
      showError(response.data.message[0]?.validation_results);
    } else {
      triggerSnackbar(response.data.message ?? response.data.error, "warning");
    }
    return response.data;
  },
  (error) => {
    // Handle errors if needed
    const { status } = error?.response;
    if (status === 401) {
      triggerSnackbar(
        error?.response.data.message ?? error?.response.data.msg,
        "error"
      );
      removeLocalStorageItem("access_token");
      window.location.href = "/";
    }
    if (status && status >= 400 && status < 500) {
      if (
        typeof error?.response?.data?.message === "string" ||
        typeof error?.response?.data?.error === "string"
      ) {
        showError(error?.response.data.message ?? error?.response.data.error);
      } else {
        showError(error?.response.data.message?.[0]?.validation_results);
      }
    } else if (status && status >= 500) {
      if (
        typeof error?.response?.data?.message === "string" ||
        typeof error?.response?.data?.error === "string"
      ) {
        showError(error?.response.data.message ?? error?.response.data.error);
      } else {
        showError(error?.response.data.message[0]?.validation_results);
      }
    }
    return Promise.reject(error);
  }
);

export default ApiService;
